import React, { useMemo } from "react";
import { ICellRendererParams } from "ag-grid-community";

import { ExtendedPermission, PermissionLevel } from "fond/types";
import { allowEditPermission } from "fond/utils/permissions";

import SelectField from "../SelectField";

import { getOptions } from "./helper";

interface ISelectCellRendererParams extends ICellRendererParams<ExtendedPermission, ExtendedPermission> {
  currentUsername: string;
  currentPermission: PermissionLevel;
}

const SelectCellRenderer: React.FC<ISelectCellRendererParams> = ({ value: permission, node, currentUsername, currentPermission }) => {
  const options = useMemo(() => getOptions(permission, currentPermission, permission?.External), [currentPermission, permission]);

  if (!permission) return null;
  const disabled = permission?.Remove || permission?.Submitted || !allowEditPermission(permission, currentUsername, currentPermission);
  return (
    <SelectField
      margin="dense"
      name={`Users[${node.sourceRowIndex}].Level`}
      data-testid="share-permission-level-dropdown"
      variant="standard"
      options={options}
      disabled={disabled}
      menuStyle={{ fontSize: 16 }}
      sxProps={{ marginTop: "5px" }}
    />
  );
};

export default SelectCellRenderer;
